require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2017-11-loop-city.json") })
        }
      }, "path---articles-2017-11-loop-city");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2017-11-loop-city!./.cache/json/articles-2017-11-loop-city.json
// module id = 387
// module chunks = 231608221292675